import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const PasteTextTab: React.FC<Props> = ({ value, onChange }) => {
  const [displayWordCount, setDisplayWordCount] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      const trimmed = value.trim();
      setDisplayWordCount(trimmed ? trimmed.split(/\s+/).length : 0);
    }, 250);
    return () => clearTimeout(timer);
  }, [value]);

  const wordCount = displayWordCount;

  const handleClear = () => {
    onChange("");
  };

  return (
    <div className="animate-in fade-in slide-in-from-bottom-2 duration-300">
      <div className="flex items-center justify-between mb-2">
        <label className="text-sm font-semibold text-slate-700">
          Content to Analyze
        </label>
        {value && (
          <button
            onClick={handleClear}
            className="flex items-center gap-1.5 text-xs text-slate-500 hover:text-slate-700 transition-colors"
          >
            <X size={14} />
            Clear
          </button>
        )}
      </div>

      <textarea
        className="w-full h-48 p-4 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all resize-none text-slate-700 placeholder:text-slate-400"
        placeholder="Paste your article, email, or report content here..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />

      <div className="flex justify-between mt-2 text-xs">
        <div className="flex items-center gap-2">
          <span className="text-slate-400">
            {wordCount} word{wordCount !== 1 ? "s" : ""}
          </span>
          {wordCount < 50 && wordCount > 0 && (
            <span className="text-orange-600 font-medium">
              Minimum 50 words required
            </span>
          )}
          {wordCount >= 50 && (
            <span className="text-green-600 font-medium">Ready to analyze</span>
          )}
        </div>
        <span className="text-slate-400">Max 50,000 characters</span>
      </div>
    </div>
  );
};

export default PasteTextTab;
